import { render, staticRenderFns } from "./VacationOptionsModal.vue?vue&type=template&id=70a2aa74&scoped=true&"
import script from "./VacationOptionsModal.vue?vue&type=script&lang=ts&"
export * from "./VacationOptionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2aa74",
  null
  
)

export default component.exports